import {
  Button,
  Footer,
  Header,
  Heading,
  Paragraph,
  ScrollView,
} from "@/components";

export const ActiveVisitScreen = ({
  onAcknowledge,
}: {
  onAcknowledge: () => void;
}) => (
  <>
    <ScrollView
      flex={1}
      contentContainerStyle={{
        flex: 1,
        paddingHorizontal: "$200",
        paddingBottom: "$400",
      }}
    >
      <Header gap="$100">
        <Heading size="$xl">You already have an active visit</Heading>
        <Paragraph>Finish your current visit before continuing.</Paragraph>
      </Header>
    </ScrollView>
    <Footer mode="dialog" padding="$200">
      <Button
        dataTrackingId="active-visit-acknowledge-button"
        mode="primary"
        constrained
        onPress={onAcknowledge}
      >
        Got it
      </Button>
    </Footer>
  </>
);
